// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
// The maintenance hold (A3U6): AppConfigHold brings the app here and takes it back to `from` when maintenance ends.
import { ids } from '@orca/api-client/testIds'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Button } from '../components/ui/button'
import { Icon } from '../components/ui/icons'
import { Mark } from '../features/auth/AuthFrame'
import { appConfigQuery } from '../shared/appConfig/appConfig'
import '../shared/appConfig/strings'
import { t } from '../shared/i18n/i18n'

export const Route = createFileRoute('/maintenance')({
  staticData: { screenId: 'AppHoldMaintenanceScreen', access: 'anyone; maintenance on' },
  validateSearch: (search: Record<string, unknown>): { from?: string } =>
    typeof search.from === 'string' ? { from: search.from } : {},
  component: AppHoldMaintenanceScreen,
})

// Board getin-maintenance (A13U1): the mark, the turning ring, when Orca is back and Try again, which asks /app-config
// now instead of waiting for the next poll; AppConfigHold takes the app back as soon as the answer says it is over.
function AppHoldMaintenanceScreen() {
  const { queryClient } = Route.useRouteContext()
  const config = useQuery(appConfigQuery, queryClient)
  const maintenance = config.data?.maintenance
  const until = maintenance?.until ? new Date(maintenance.until) : null
  return (
    <main
      data-testid={ids.appHoldMaintenance.root}
      className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-(--stack-sm) p-(--inset-xl) text-center"
    >
      <Mark size={40} />
      <span
        aria-hidden
        className="glacier mt-(--stack-sm) grid size-16 place-items-center rounded-full text-on-header shadow-(--shadow-primary)"
      >
        <Icon name="refresh" className="glacier-body size-7" />
      </span>
      <h1 data-testid={ids.appHoldMaintenance.titleValue} className="font-display text-title-1">
        {t('appConfig.maintenance.title')}
      </h1>
      <p data-testid={ids.appHoldMaintenance.bodyValue} className="text-fg-muted">
        {maintenance?.message || t('appConfig.maintenance.body')}
      </p>
      {until && !Number.isNaN(until.getTime()) && (
        <p className="text-fg-muted">
          {t('appConfig.maintenance.until', { time: until.toLocaleTimeString([], { timeStyle: 'short' }) })}
        </p>
      )}
      <Button
        data-testid={ids.appHoldMaintenance.retryButton}
        loading={config.isFetching}
        onClick={() => void config.refetch()}
      >
        {t('appConfig.maintenance.retry')}
      </Button>
      <p data-testid={ids.appHoldMaintenance.progress} role="status" className="text-body-md text-fg-muted">
        {t('appConfig.maintenance.checking')}
      </p>
    </main>
  )
}
